import PopupPlugin from './popup';
import PaginationPlugin from './pagination';
import YxTable from './yx-table';
import YxAutoComplete from './yx-auto-complete';
import echartsPlugin from './echarts';
import MultInput from './mult-input';

export default {
  // popups 所有的弹窗异步组件
  install: (application, popups) => {
    application.use(PopupPlugin, popups);
    application.use(PaginationPlugin);
    application.use(YxTable);
    application.use(YxAutoComplete);
    application.use(echartsPlugin);
    application.use(MultInput);
  },
};
